import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
} from "reactstrap";

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'

export default class NhomKhEdit extends Component {
  constructor(props) {
    super(props);
  }
  valueChange = ({target}) => {
    let item = this.props.item
    switch (target.name) {
      case 'Ten':
        item[target.name] = target.value
        break;
    }
    this.props.updateDataFields(item)
  }
  onClose = () => {
    this.props.updateDataFields({item: {}})
    this.props.onClose()
  }
  render() {
    const {
      item,
      isOpenDlg,
      requesting,
      errors,
      messages,
    } = this.props

    return (
      <div className="animated fadeIn">
        <Modal isOpen={isOpenDlg} className="modal-md">
          <ModalHeader>Cập nhật/ thêm mới nhóm khách hàng</ModalHeader>
          <ModalBody>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <span className="input-group-text" htmlFor="Ten">Tên nhóm</span>
                </div>
                <div className="display-table-cell">
                  <Input name="Ten" type="textbox" maxLength="200" value={item.Ten || ''} onChange={e => this.valueChange(e)} />
                </div>
              </div>
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              {!requesting && !!errors.length && (
                <Errors message="Failure to signup due to:" errors={errors} />
              )}
              {!requesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              <div className="btn-group float-right" role="group">
                <Button disabled={requesting} className="btn btn-success mr-1" onClick={() => this.props.updateNhomKh(item)}>
                  <i className="fa fa-save"></i><span className="d-none d-sm-inline">&nbsp;Lưu</span></Button>
                <Button className="btn btn-secondary" onClick={() => this.onClose()}>
                  <i className="fa fa-arrow-left"></i><span className="d-none d-sm-inline">&nbsp;Đóng</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/_NhomKhEdit.js